import React from "react";
import SearchResultsGroup from "../SearchResultsGroup/SearchResultsGroup";

const SearchResults = ({ results }) => {
    // console.log("SearchResults: Render!");

    return (
        <>
            {results.categories.length ? (
                <SearchResultsGroup
                    title="Категории материалов"
                    items={results.categories}
                    parentKey="parent_name"
                />
            ) : null}

            {results.materials.length ? (
                <SearchResultsGroup
                    title="Материалы"
                    items={results.materials}
                />
            ) : null}

            {results.service_categories.length ? (
                <SearchResultsGroup
                    title="Категории услуг"
                    items={results.service_categories}
                />
            ) : null}

            {results.services.length ? (
                <SearchResultsGroup title="Услуги" items={results.services} />
            ) : null}

            {results.solutions_with_type.length ? (
                <SearchResultsGroup
                    title="Готовые решения по типу"
                    items={results.solutions_with_type}
                    parentKey="type_name"
                />
            ) : null}

            {results.solutions_with_purpose.length ? (
                <SearchResultsGroup
                    title="Готовые решения по назначению"
                    items={results.solutions_with_purpose}
                    parentKey="purpose_name"
                />
            ) : null}

            {results.solutions.length ? (
                <SearchResultsGroup
                    title="Готовые решения"
                    items={results.solutions}
                />
            ) : null}

            {results.cases.length ? (
                <SearchResultsGroup
                    title="Наши объекты"
                    items={results.cases}
                    afterKey="location"
                />
            ) : null}
        </>
    );
};

export default SearchResults;
